import * as yup from 'yup';

const covSurfaceRequired = yup
  .number()
  .typeError('Número no válido')
  .required('Este campo es obligatorio')
  .positive('El número debe ser mayor a 0')
  .max(
    yup.ref('totalSurface'),
    'La superficie cubierta no puede ser mayor a la total'
  );

const covSurfaceNoReq = yup
  .number()
  .typeError('Número no válido')
  .positive('El número debe ser mayor a 0')
  .max(
    yup.ref('totalSurface'),
    'La superficie cubierta no puede ser mayor a la total'
  );

export const surface = covSurfRequired =>
  yup.object().shape({
    totalSurface: yup
      .number()
      .typeError('Número no válido')
      .required('Este campo es obligatorio')
      .positive('El número debe ser mayor a 0'),
    coveredSurface: covSurfRequired ? covSurfaceRequired : covSurfaceNoReq,
    uncoveredSurface: yup
      .number()
      .typeError('Número no válido')
      .positive('El número debe ser mayor a 0')
      .max(
        yup.ref('totalSurface'),
        'La superficie descubierta no puede ser mayor a la total'
      ),
    semiCoveredSurface: yup
      .number()
      .typeError('Número no válido')
      .positive('El número debe ser mayor a 0')
      .max(
        yup.ref('totalSurface'),
        'La superficie semicubierta no puede ser mayor a la total'
      ),
    exclusiveSurface: yup
      .number()
      .typeError('Número no válido')
      .positive('El número debe ser mayor a 0')
      .max(
        yup.ref('totalSurface'),
        'La superficie exclusiva no puede ser mayor a la total'
      )
  });
